import { render, staticRenderFns } from "./UpdoxFooter.vue?vue&type=template&id=8c07bd1a&scoped=true"
import script from "./UpdoxFooter.vue?vue&type=script&lang=js"
export * from "./UpdoxFooter.vue?vue&type=script&lang=js"
import style0 from "./UpdoxFooter.vue?vue&type=style&index=0&id=8c07bd1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c07bd1a",
  null
  
)

export default component.exports